<template>
  <a-select :allow-clear="allowClear" v-model:value="selectedKey" show-search :filter-option="filterOption" :mode="mode"
    :options="options" class="main" placeholder="请选择">
  </a-select>
</template>

<script setup lang='ts'>
import { computed, ref } from 'vue'

const props = withDefaults(defineProps<{
  value: string[] | string | number[] | number | undefined,
  mode?: 'multiple' | 'single',
  options: [],
  allowClear?: boolean
}>(), {
  allowClear: true
})
const emit = defineEmits(['update:value', 'onSelect'])

const selectedKey = computed({
  get() {
    return props.value
  },
  set(val) {
    emit('update:value', val)
    emit('onSelect', val)
  }
})
const filterOption = (input: string, option: any) => {
  return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

</script>

<style lang='scss' scoped>
.main {
  min-width: 150px;
}
</style>